import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTopSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChevronTopSmall"><Path fillRule="evenodd" clipRule="evenodd" d="M12.0002 8.58594L17.4144 14.0002L16.0002 15.4144L12.0002 11.4144L8.00015 15.4144L6.58594 14.0002L12.0002 8.58594Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronTopSmall;
